import { render, staticRenderFns } from "./SideSection.vue?vue&type=template&id=d44fcd3c&scoped=true&"
import script from "./SideSection.vue?vue&type=script&lang=js&"
export * from "./SideSection.vue?vue&type=script&lang=js&"
import style0 from "./SideSection.vue?vue&type=style&index=0&id=d44fcd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44fcd3c",
  null
  
)

export default component.exports